import { toNumber } from 'lodash';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Order, OrderActionEvent, OrderBusEvent } from 'src/app/shared';
import { OrderActionHandlerService } from 'src/app/feature/payment/services/order-action-handler.service';
import { OrderService } from 'src/app/feature/services';
import { UserService } from 'src/app/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

const _ = require('lodash');

@Component({
  selector: 'shopping-cart-dropdown',
  templateUrl: './shopping-cart-dropdown.component.html',
  styleUrls: ['./shopping-cart-dropdown.component.scss'],
})
export class ShoppingCartDropdownComponent implements OnInit, OnChanges {
  @Input('orders') orders!: Order[];
  @Input() isAuthenticated? = false;
  @Output() showBasket: EventEmitter<null> = new EventEmitter();
  @Output() closeShoppingCard = new EventEmitter();
  public totalPrice: number = 0;

  constructor(
    private orderAction: OrderActionHandlerService,
    private ordersService: OrderService,
    private userService: UserService,

    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public options?: { isDialog: boolean; orders: Order[] }
  ) {
  }

  getShoppingCard() {
    if (this.isAuthenticated) {
      if (!this.options || (this.options && !this.options.orders)) {
        this.ordersService
          .load({ justShoppingCart: true })
          .then((orders: Order[]) => {
            this.orders = orders;
            this.userService.userOrders.next(orders);
            if (this.orders?.length >= 0) this.getTotalPrice();
          });
      } else {
        this.orders = this.options.orders;
        if (this.orders?.length >= 0) this.getTotalPrice();
      }
    }
  }
  ngOnInit(): void {
    this.getShoppingCard();
    this.userService.userOrders.subscribe((orders) => {
      this.orders = orders;
      if (this.orders?.length >= 0) this.getTotalPrice();
    });

    this.orderAction.subscribe((change) => {
      if (typeof change === 'boolean') {
        return;
      }

      const index = this?.orders.findIndex((order) => {
        return order?.id === (change as OrderActionEvent<Order>).data?.id;
      });

      this.orders[index] = (change as OrderActionEvent<Order>).data;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isAuthenticated']?.currentValue) {
      this.getShoppingCard();
    }
  }

  public deleteOrder(i: number) {
    this.orders.splice(i, 1);
    this.getShoppingCard();
  }

  public getOrders() {
    if (!this?.orders || !this.orders?.length) {
      return [];
    }
    return this.orders;
  }

  public getTotalPrice() {
    const prices = (this?.orders || [])?.map((order) => order.price);
    const calculated = (() => {
      let t: number = 0;

      for (let price of _.compact(prices)) {
        t = t + (typeof price === 'number' ? price : toNumber(price || 0));
      }

      return t;
    })();
    this.totalPrice = calculated || 0;
  }

  goToBasket() {
    this.showBasket.emit();
  }
}
